





























import Vue from 'vue'
import { mapState } from 'vuex'

import properties from '@/components/administration/Properties'
import statistics from '@/components/administration/Statistics'
import activities from '@/components/administration/Activities'
import table from '@/components/administration/Table'


export default {
  name: 'Administration'

  components: 
    'v-properties': properties
    'v-statistics': statistics
    'v-activities': activities
    'v-table': table


  mounted: () ->
    componentHandler.upgradeElements @$el

  beforeDestroy: ()->
    componentHandler.downgradeElements @$el


  computed:
    mapState
      isLoading: (state) ->
        state.xhr_is_loadings

}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Administration.vue